const transitionStyles = {
  ".snackbar-enter": {
    opacity: 0,
  },
  ".snackbar-exit-active": {
    opacity: 0,
  },
  ".snackbar-enter-active": {
    opacity: 1,
  },
  ".snackbar-enter-top-center": {
    transform: "translateY(-16px)",
  },
  ".snackbar-enter-top-right": {
    transform: "translateY(-16px)",
  },
  ".snackbar-exit-active-top-left": {
    transform: "translateY(-16px)",
  },
  ".snackbar-exit-active-top-center": {
    transform: "translateY(-16px)",
  },
  ".snackbar-exit-active-top-right": {
    transform: "translateY(-16px)",
  },
  ".snackbar-enter-bottom-left": {
    transform: "translateY(16px)",
  },
  ".snackbar-enter-bottom-center": {
    transform: "translateY(16px)",
  },
  ".snackbar-enter-bottom-right": {
    transform: "translateY(16px)",
  },
  ".snackbar-exit-active-bottom-left": {
    transform: "translateY(16px)",
  },
  ".snackbar-exit-active-bottom-center": {
    transform: "translateY(16px)",
  },
  ".snackbar-exit-active-bottom-right": {
    transform: "translateY(16px)",
  },
  ".snackbar-enter-active-top-left": {
    transform: "translateY(0px)",
  },
  ".snackbar-enter-active-top-center": {
    transform: "translateY(0px)",
  },
  ".snackbar-enter-active-top-right": {
    transform: "translateY(0px)",
  },
  ".snackbar-enter-active-bottom-left": {
    transform: "translateY(0px)",
  },
  ".snackbar-enter-active-bottom-center": {
    transform: "translateY(0px)",
  },
  ".snackbar-enter-active-bottom-right": {
    transform: "translateY(0px)",
  },
  ".snackbar-wrapper-top-left": {
    justifyContent: "flex-start",
    top: "8px",
  },
  ".snackbar-wrapper-top-center": {
    top: "8px",
    justifyContent: "center",
  },
  ".snackbar-wrapper-top-right": {
    top: "8px",
    justifyContent: "flex-end",
  },
  ".snackbar-wrapper-bottom-left": {
    bottom: "8px",
    justifyContent: "flex-start",
  },
  ".snackbar-wrapper-bottom-center": {
    bottom: "8px",
    justifyContent: "center",
  },
  ".snackbar-wrapper-bottom-right": {
    bottom: "8px",
    justifyContent: "flex-end",
  },
} as const;

export default transitionStyles;
